import { DealUserTypeEnum, DealUserTypeLabel } from '@modules/ContactManager/components/Tabs/components/Deals/interfaces';

export const MILITARY_RANK_OPTIONS = [
  {
    value: 'E01',
    label: 'E01',
  },
  {
    value: 'E02',
    label: 'E02',
  },
  {
    value: 'E03',
    label: 'E03',
  },
  {
    value: 'E04',
    label: 'E04',
  },
  {
    value: 'E05',
    label: 'E05',
  },
  {
    value: 'E06',
    label: 'E06',
  },
  {
    value: 'E07',
    label: 'E07',
  },
  {
    value: 'E08',
    label: 'E08',
  },
  {
    value: 'E09',
    label: 'E09',
  },
  {
    value: 'E10',
    label: 'E10',
  },
  {
    value: 'W01',
    label: 'W01',
  },
  {
    value: 'W02',
    label: 'W02',
  },
  {
    value: 'W03',
    label: 'W03',
  },
  {
    value: 'W04',
    label: 'W04',
  },
  {
    value: 'W05',
    label: 'W05',
  },
  {
    value: 'W06',
    label: 'W06',
  },
  {
    value: 'W07',
    label: 'W07',
  },
  {
    value: 'W08',
    label: 'W08',
  },
  {
    value: 'W09',
    label: 'W09',
  },
  {
    value: 'W10',
    label: 'W10',
  },
  {
    value: 'O01',
    label: 'O01',
  },
  {
    value: 'O02',
    label: 'O02',
  },
  {
    value: 'O03',
    label: 'O03',
  },
  {
    value: 'O04',
    label: 'O04',
  },
  {
    value: 'O05',
    label: 'O05',
  },
  {
    value: 'O06',
    label: 'O06',
  },
  {
    value: 'O07',
    label: 'O07',
  },
  {
    value: 'O08',
    label: 'O08',
  },
  {
    value: 'O09',
    label: 'O09',
  },
  {
    value: 'O10',
    label: 'O10',
  },
];

export const RESIDENT_TYPE_OPTIONS = [
  {
    label: 'Citizen',
    value: 'Citizen',
  },
  {
    label: 'Resident',
    value: 'Resident',
  },
  {
    label: 'Tin',
    value: 'Tin',
  },
  {
    label: 'WorkVisa',
    value: 'WorkVisa',
  },
];

export const ASSET_TYPE_OPTIONS = [
  { value: 'Apartment', label: 'Apartment' },
  { value: 'Boat', label: 'Boat' },
  { value: 'Car', label: 'Car' },
  { value: 'Commercial', label: 'Commercial' },
  { value: 'EducationLoan', label: 'Education Loan' },
  { value: 'House', label: 'House' },
  { value: 'Jetski', label: 'Jetski' },
  { value: 'Motorcycle', label: 'Motorcycle' },
  { value: 'Other', label: 'Other' },
  { value: 'PowerSports', label: 'Power Sports' },
  { value: 'Rv', label: 'Rv' },
  { value: 'Savings', label: 'Savings' },
  { value: 'Snowmobile', label: 'Snowmobile' },
  { value: 'Suv', label: 'Suv' },
  { value: 'Trailer', label: 'Trailer' },
  { value: 'Truck', label: 'Truck' },
];

export const assetConditions = [
  { value: 'New', label: 'New' },
  { value: 'Used', label: 'Used' },
];

export const assetValidations = [
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' },
];

export const downPaymentStatuses = [
  {
    label: 'Missing Down Payment Info',
    value: 'Missing Down Payment Info',
  },
  {
    label: 'Pending Down Payment',
    value: 'Pending Down Payment',
  },
  {
    label: 'Down Payment Declined',
    value: 'Down Payment Declined',
  },
  {
    label: 'Down Payment Completed',
    value: 'Down Payment Completed',
  },
];
export const dealFeesCategories = [
  {
    label: 'GP Deal',
    value: 'GP Deal',
  },
  {
    label: 'Commission',
    value: 'Commission',
  },
  {
    label: 'Florida Stamp',
    value: 'Florida Stamp',
  },
  {
    label: 'Registration fees',
    value: 'Registration fees',
  },
];
export const incomeTypes = [
  { label: 'Other', value: '1' },
  { label: 'Rental Property', value: '2' },
  { label: 'Child Support', value: '4' },
  { label: 'Retirement', value: '5' },
  { label: 'Military', value: '7' },
  { label: 'Disability', value: '8' },
  { label: 'Va Benefits', value: '9' },
  { label: 'Social Security Ssi', value: '10' },
  { label: 'Employment Income', value: '12' },
];

export const PERMISSIONS_OPTIONS = [
  {
    value: 'Admin',
    label: 'Admin',
  },
  {
    value: 'ViewDocGen',
    label: 'ViewDocGen',
  },
  {
    value: 'ViewTitleDocGen',
    label: 'ViewTitleDocGen',
  },
  {
    value: 'ViewTitleAudit',
    label: 'ViewTitleAudit',
  },
  {
    value: 'ViewTitleApp',
    label: 'ViewTitleApp',
  },
  {
    value: 'ContactCreate',
    label: 'ContactCreate',
  },
  {
    value: 'ContactUpdate',
    label: 'ContactUpdate',
  },
  {
    value: 'GenerateDocGen',
    label: 'GenerateDocGen',
  },
  {
    value: 'GenerateTitleDocGen',
    label: 'GenerateTitleDocGen',
  },
  {
    value: 'GenerateTitleAudit',
    label: 'GenerateTitleAudit',
  },
  {
    value: 'GenerateTitleApp',
    label: 'GenerateTitleApp',
  },
  {
    value: 'DripFeeder',
    label: 'DripFeeder',
  },
  {
    value: 'WorkflowCreate',
    label: 'WorkflowCreate',
  },
];

export const ROLE_TYPE_OPTIONS = ['UserRole', 'DripFeeder'];
export const SERVICE_TYPES = [
  {
    id: 1,
    name: 'EUROPE_FIRST_INTERNATIONAL_PRIORITY',
  },
  {
    id: 2,
    name: 'FEDEX_1_DAY_FREIGHT',
  },
  {
    id: 3,
    name: 'FEDEX_2_DAY',
  },
  {
    id: 4,
    name: 'FEDEX_2_DAY_AM',
  },
  {
    id: 5,
    name: 'FEDEX_2_DAY_FREIGHT',
  },
  {
    id: 6,
    name: 'FEDEX_3_DAY_FREIGHT',
  },
  {
    id: 7,
    name: 'FEDEX_DISTANCE_DEFERRED',
  },
  {
    id: 8,
    name: 'FEDEX_EXPRESS_SAVER',
  },
  {
    id: 9,
    name: 'FEDEX_FIRST_FREIGHT',
  },
  {
    id: 10,
    name: 'FEDEX_FREIGHT_ECONOMY',
  },
  {
    id: 11,
    name: 'FEDEX_FREIGHT_PRIORITY',
  },
  {
    id: 12,
    name: 'FEDEX_GROUND',
  },
  {
    id: 13,
    name: 'FEDEX_NEXT_DAY_AFTERNOON',
  },
  {
    id: 14,
    name: 'FEDEX_NEXT_DAY_EARLY_MORNING',
  },
  {
    id: 15,
    name: 'FEDEX_NEXT_DAY_END_OF_DAY',
  },
  {
    id: 16,
    name: 'FEDEX_NEXT_DAY_FREIGHT',
  },
  {
    id: 17,
    name: 'FEDEX_NEXT_DAY_MID_MORNING',
  },
  {
    id: 18,
    name: 'FIRST_OVERNIGHT',
  },
  {
    id: 19,
    name: 'GROUND_HOME_DELIVERY',
  },
  {
    id: 20,
    name: 'INTERNATIONAL_ECONOMY',
  },
  {
    id: 21,
    name: 'INTERNATIONAL_ECONOMY_FREIGHT',
  },
  {
    id: 22,
    name: 'INTERNATIONAL_FIRST',
  },
  {
    id: 23,
    name: 'INTERNATIONAL_PRIORITY',
  },
  {
    id: 24,
    name: 'INTERNATIONAL_PRIORITY_EXPRESS',
  },
  {
    id: 25,
    name: 'INTERNATIONAL_PRIORITY_FREIGHT',
  },
  {
    id: 26,
    name: 'PRIORITY_OVERNIGHT',
  },
  {
    id: 27,
    name: 'SAME_DAY',
  },
  {
    id: 28,
    name: 'SAME_DAY_CITY',
  },
  {
    id: 29,
    name: 'SMART_POST',
  },
  {
    id: 30,
    name: 'STANDARD_OVERNIGHT',
  },
];

export const CONDITIONS_TYPE_OPTIONS = [
  {
    value: 'Cash Out',
    label: 'Cash Out',
  },
  {
    value: 'No Cash-Out',
    label: 'No Cash-Out',
  },
  {
    value: 'New Auto',
    label: 'New Auto',
  },
  {
    value: 'Used Auto',
    label: 'Used Auto',
  },
  {
    value: 'New Motorcycle',
    label: 'New Motorcycle',
  },
  {
    value: 'Used Motorcycle',
    label: 'Used Motorcycle',
  },
];

export const DEAL_USERS_OPTIONS = [
  {
    value: DealUserTypeEnum.SDR,
    label: DealUserTypeLabel[DealUserTypeEnum.SDR],
  },
  {
    value: DealUserTypeEnum.Lc,
    label: DealUserTypeLabel[DealUserTypeEnum.Lc],
  },
  {
    value: DealUserTypeEnum.Bank,
    label: DealUserTypeLabel[DealUserTypeEnum.Bank],
  },
  {
    value: DealUserTypeEnum.Lp,
    label: DealUserTypeLabel[DealUserTypeEnum.Lp],
  },
  {
    value: DealUserTypeEnum.Account,
    label: DealUserTypeLabel[DealUserTypeEnum.Account],
  },
  {
    value: DealUserTypeEnum.Title,
    label: DealUserTypeLabel[DealUserTypeEnum.Title],
  },
];

export enum TimeZoneList {
  AKST = 'America/Anchorage',
  AKDT = 'America/Anchorage',
  AST = 'America/Juneau',
  PST = 'America/Los_Angeles',
  PDT = 'America/Los_Angeles',
  MST = 'America/Denver',
  MDT = 'America/Denver',
  CST = 'America/Chicago',
  CDT = 'America/Chicago',
  EST = 'America/New_York',
  EDT = 'America/New_York',
  HST = 'America/Honolulu',
}
